'use strict';
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/mcs-client/node_modules/core-js/internals/iterators.js
// module id = 861
// module chunks = 25